var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DashOrder = /** @class */ (function () {
    function DashOrder() {
    }
    return DashOrder;
}());
var DashAddress = /** @class */ (function () {
    function DashAddress() {
    }
    DashAddress.areExactMatch = function (a, b) {
        var _this = this;
        var obj = Object.keys, ta = typeof a, tb = typeof b;
        return a && b && ta === 'object' && ta === tb ? (obj(a).length === obj(b).length &&
            obj(a).every(function (key) { return _this.areExactMatch(a[key], b[key]); }) && a.constructor === b.constructor) :
            (a === b && (a != null && b != null));
    };
    return DashAddress;
}());
var DashOrderDetails = /** @class */ (function (_super) {
    __extends(DashOrderDetails, _super);
    function DashOrderDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DashOrderDetails.prototype.hasChanges = function () {
        var orig = this.original;
        return !(this.customerName === orig.customerName &&
            this.invoiceStatusId === orig.invoiceStatusId &&
            this.orderStatus === orig.orderStatus &&
            this.invoicePrinted === orig.invoicePrinted &&
            DashAddress.areExactMatch(this.billingAddress, orig.billingAddress) &&
            DashAddress.areExactMatch(this.shippingAddress, orig.shippingAddress));
    };
    DashOrderDetails.createFromOriginal = function (original) {
        var dod = new DashOrderDetails();
        Object.assign(dod, original);
        dod.original = original;
        return dod;
    };
    return DashOrderDetails;
}(DashOrder));
var DashCustomOrderNoteRequest = /** @class */ (function () {
    function DashCustomOrderNoteRequest() {
    }
    return DashCustomOrderNoteRequest;
}());
var OrderNoteLogLevel;
(function (OrderNoteLogLevel) {
    OrderNoteLogLevel["Info"] = "Info";
    OrderNoteLogLevel["Success"] = "Success";
    OrderNoteLogLevel["Error"] = "Error";
})(OrderNoteLogLevel || (OrderNoteLogLevel = {}));
var DashOrderItem = /** @class */ (function () {
    function DashOrderItem() {
    }
    return DashOrderItem;
}());
export { DashOrder, DashAddress, DashOrderDetails, DashOrderItem, DashCustomOrderNoteRequest, OrderNoteLogLevel };
